/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListDirectoryRoleMappingsSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListDirectoryRoleMappingsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListDirectoryRoleMappingsSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListDirectoryRoleMappingsSecurity$outboundSchema: z.ZodMiniType<
  ListDirectoryRoleMappingsSecurity$Outbound,
  ListDirectoryRoleMappingsSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listDirectoryRoleMappingsSecurityToJSON(
  listDirectoryRoleMappingsSecurity: ListDirectoryRoleMappingsSecurity,
): string {
  return JSON.stringify(
    ListDirectoryRoleMappingsSecurity$outboundSchema.parse(
      listDirectoryRoleMappingsSecurity,
    ),
  );
}

/** @internal */
export type ListDirectoryRoleMappingsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListDirectoryRoleMappingsRequest$outboundSchema: z.ZodMiniType<
  ListDirectoryRoleMappingsRequest$Outbound,
  ListDirectoryRoleMappingsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function listDirectoryRoleMappingsRequestToJSON(
  listDirectoryRoleMappingsRequest: ListDirectoryRoleMappingsRequest,
): string {
  return JSON.stringify(
    ListDirectoryRoleMappingsRequest$outboundSchema.parse(
      listDirectoryRoleMappingsRequest,
    ),
  );
}
